import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { LocalStorageService } from '../services/local-storage.service';
import { environment } from 'src/environments/environment';
import { decrypt } from './crypt.helper';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class xKeyIInterceptor implements HttpInterceptor {
  constructor(private readonly lsService: LocalStorageService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('https://viacep.com.br')) {
      // if (location.pathname == '/simulation') {
      //   // // X-XSS-Protection
      //   let request = req.clone({
      //     headers: req.headers.set('X-XSS-Protection', `1; mode=block`)
      //   });
      //   return next.handle(request);
      // } else {
        const xKeyI = JSON.parse(decrypt(sessionStorage.getItem(environment.localpoints.authResult))).xKeyI;
        const auth = req.clone({
          headers: req.headers.set('xkeyI', xKeyI)
        });
        return next.handle(auth);
      // }
    } else {
      return next.handle(req);
    }
  }
}
